// extracted by mini-css-extract-plugin
export default {"main":"ButtonTrash_main__fCZFl","icon":"ButtonTrash_icon__dGSFz"};